import * as angular from "angular";
import { Integration } from "../../models/integration.model";
import { IntegrationDataProvider } from "../../data-provider/integration.dp";
import { Utils } from "../../helper/utils.helper";

let IntegrationList = {
    selector: "vcIntegrationList",
    templateUrl:
        "/angular/components/integration/integration-list.component.html",
    bindings: {},
    controller: class IntegrationListController {
        public loading = false;
        public integrations: Integration[] = [];

        public __env: any;
        private dataProvider: IntegrationDataProvider;

        constructor(
            __env: any,
            IntegrationDataProvider: IntegrationDataProvider,
            Utils: Utils
        ) {
            Utils.accessCheck();

            this.__env = __env;
            this.dataProvider = IntegrationDataProvider;

            this.getIntegrations();
        }

        getIntegrations(): void {
            this.loading = true;
            this.dataProvider
                .getAllIntegrations()
                .then((integrations: Integration[]) => {
                    this.loading = false;
                    this.integrations = integrations;
                });
        }
    },
};

angular
    .module("integration")
    .component(IntegrationList.selector, IntegrationList);
